import React, { useState } from 'react'
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";

import CustomMenuItem from '../../../../components/Menu/CustomMenuItem';
import deleteIcon from "../../../../styles/svg/deleteUser.svg";
import FormDialog from '../../../../components/Dialog/FormDialog';
import { Typography } from '@mui/material';
import useMutate from '../../../../hooks/useMutate';
import { deleteUser } from '../../../../services/apiUser';
import { currentUserId } from '../../../../utils/constants';

function DeleteUser({ params, onMenuClose = () => {} }) {
  const [open, setOpen] = useState(false);
  const currentUser = currentUserId();
  const targetUserId = params?.row?.user_id;
  const isCurrentUser = String(currentUser) === String(targetUserId);

  
  const { mutate, isPending } = useMutate(deleteUser, ["users","boards"], () => {}, () => {
    handleClose();
  });

  const handleDeleteUser = () => {
    mutate(targetUserId);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      {open && (
        <FormDialog
          open={open}
          handleClose={handleClose}
          isLoading={isPending}
          handleSubmit={handleDeleteUser}
          buttonTxt="Delete"
          cancelBtn={true}
          alignActions={"center"}
          fullWidth={true}
          isHeader={false}
        >
          <div className="delete-confirmation">
            <ErrorOutlineOutlinedIcon className="confirmation-icon" />
            <Typography className="delete-confirmation-title">
              Delete User?
            </Typography>
            <Typography className="delete-confirmation-description">
            Are you sure you want to permanently delete this user?
            This action cannot be undone.
            </Typography>
          </div>
        </FormDialog>
      )}
      <CustomMenuItem
        onClick={() => {
          if (!isCurrentUser) {
            setOpen(true);
            onMenuClose();
          }
        }}
        disabled={isPending || isCurrentUser}
      >
        <img src={deleteIcon} className="mr-3" />
        Delete
      </CustomMenuItem>
    </>
  );
}

export default DeleteUser;
